import { guuid } from '../utils/get-random-id';

export interface StripeInstanceForTesting {
  paymentMethods: {
    create(params: any): Promise<{ id: string }>;
  };
}

export async function addCardToUser(
  email: string,
  {
    apiBaseUrl,
    headers,
    stripe,
    useDeclineCard = false,
  }: {
    apiBaseUrl: string;
    headers: Record<string, string>;
    stripe: StripeInstanceForTesting;
    useDeclineCard?: boolean;
  },
) {
  const tokenResponse = await fetch(`${apiBaseUrl}/test-auth/generate-auth-token-set`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({ email }),
  });

  if (!tokenResponse.ok) {
    throw new Error(`Failed to get auth token: ${await tokenResponse.text()}`);
  }

  const tokenData = await tokenResponse.json();
  const accessToken = tokenData.access_token;

  const cardToken = useDeclineCard ? 'tok_chargeCustomerFail' : 'tok_visa';
  const paymentMethod = await stripe.paymentMethods.create({
    type: 'card',
    card: { token: cardToken },
  });

  const setupResponse = await fetch(`${apiBaseUrl}/payments/setup-intent`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
    body: JSON.stringify({
      paymentMethodId: paymentMethod.id,
      captchaToken: guuid(),
      idempotencyKey: guuid(),
    }),
  });

  if (!setupResponse.ok) {
    throw new Error(`Failed to setup intent: ${await setupResponse.text()}`);
  }

  const updateResponse = await fetch(`${apiBaseUrl}/payments/update-card-details`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
    body: JSON.stringify({ paymentMethodId: paymentMethod.id }),
  });

  if (!updateResponse.ok) {
    throw new Error(`Failed to update card details: ${await updateResponse.text()}`);
  }
}
